import { ExpiredShopReAuthButton } from "@/components/SyncAllShopOrderButton/SyncAllShopOrderModal";
import { useGlobalStore } from "@/store/hooks";
import { Table } from "antd";
import type { TableColumnsType } from "antd";
import React from "react";

function useColumns(): TableColumnsType<{ shopId: number; message: string }> {
    const globalStore = useGlobalStore();

    return [
        {
            title: "店铺",
            key: "shopId",
            width: 200,
            render(value, record, index) {
                const shop = globalStore.shopMapping.get(record.shopId);

                const shopName = shop?.name;

                return (
                    <div style={{ wordBreak: "break-all" }}>
                        <span>{shopName}</span>
                    </div>
                );
            },
        },
        {
            title: "错误信息",
            key: "message",
            render(value, record, index) {
                if (record.message?.includes("店铺授权过期")) {
                    return <ExpiredShopReAuthButton shopId={record.shopId} />;
                }

                return <span className="error">{record.message}</span>;
            },
        },
    ];
}

export interface ShopFetchOrderError {
    message: string;
    shopId: number;
}

interface FetchOrderErrorTableProps {
    dataSource: ShopFetchOrderError[];
}

const FetchOrderErrorTable: React.FC<FetchOrderErrorTableProps> = function (props) {
    const { dataSource } = props;

    const columns = useColumns();

    return (
        <Table
            size="small"
            bordered
            dataSource={dataSource}
            columns={columns}
            pagination={false}
            scroll={{
                y: 400,
            }}
        />
    );
};

export default React.memo(FetchOrderErrorTable);
